import React, { useState, useEffect } from "react";
import Loader from '!jsx!./assets/loader.svg';

let _footer = undefined;

export default ({ isLoading = false, copy = '' }) => {

	function addHtml(html) {
		if (_footer === undefined)
			_footer = document.getElementById('footer');

		_footer.innerHTML = html;
	}

    return (
		<div className="tw-w-full">
			{isLoading === true
				? (<div className="tw-w-full tw-text-center tw-h-[72px]"><Loader /></div>)
				: (<div id="footer" className="tw-w-full tw-p-4" dangerouslySetInnerHTML={{__html:copy}} ></div>)}
		</div>
    );
};